<template>
    <div class="part">
        <el-dropdown>
            <span class="flex">
              <span class="user-name">{{nickname}}</span>
              <el-avatar :src="avatar" :size="size"  v-if="avatar"></el-avatar>
              <el-avatar src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" :size="size"  v-else></el-avatar>
            </span>
            <el-dropdown-menu slot="dropdown" class="dropdown">
              <el-dropdown-item>
                <router-link tag="a" :to="{ name: 'OrderManage' }">
                  <i class="el-icon-user"></i>
                  <span>个人中心</span>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                 <router-link tag="a" :to="{ name: 'Home' }">
                   <i class="el-icon-edit"></i>
                  <span>修改密码</span>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="handleLogout">
                  <i class="el-icon-switch-button"></i>
                  <span>退出</span>
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'UserMenu',
    computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  props:{
    size:{
      type:Number,
      required: true,
      default:25,
    }
  },
  methods:{
    ...mapActions(['Logout']),
    handleLogout(){
      Vue.prototype.$confim('真的要注销登录吗 ?','提示',{
         confirmButtonText: '确定',
         cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.Logout().then(() => {
           Vue.prototype.$message({
            type: 'success',
            message: '退出成功!'
          });
          setTimeout(() => {
              window.location.reload()
              this.$router.replace({ path:'/'})
            }, 16)
          
        })
      }).catch(() => {
          Vue.prototype.$message({
            type: 'info',
            message: '已取消退出'
          }); 
       }); 
    },
  }
}
</script>

<style scoped>
.part .flex{align-items: center;}
.user-name{color: #b0b0b0;padding: 0 13px;font-size: 12px;}
.dropdown >>> .el-dropdown-menu__item{padding:  0;}
.dropdown >>> .el-dropdown-menu__item a{padding: 0 20px;display: block;}
</style>